import React from 'react'
import logo from '../img/logo.png';

const Header = () => {
    return (
        <header className='center'>
            <img src={logo} alt=''></img>

        </header>
    )
}

export default Header

